<template>
  <div>
    <b-table
      :sticky-header="stickyHeader"
      :no-border-collapse="noCollapse"

      responsive
      :items="items"
      :fields="fields"
    >
      <template #head(id)>
        <div class="text-nowrap">
          Row ID
        </div>
      </template>

      <template #head()="scope">
        <div class="text-nowrap">
          {{ scope.label }}
        </div>
      </template>

      <template #cell(avatar)="data">
        <b-avatar
          class="mr-1"
          :src="data.value"
        />
      </template>

      <template #cell(message_id)="data">

        <b-badge
          v-if="data.item.send == null && data.item.message_id == null"
          :variant="status[1][3]"
        >
          {{ status[0][3] }}
        </b-badge>

        <b-badge
          v-else
          :variant=" (data.value) ? status[1][1] : status[1][2]"
        >
          {{ (data.value) ? status[0][1] : status[0][2] }}
        </b-badge>

      </template>

      <template #cell()="data">
        <span class="text-nowrap">{{ data.value }}</span>
      </template>
    </b-table>
  </div>
</template>

<script>
import {
  BTable, BFormCheckbox, BAvatar, BBadge,
} from 'bootstrap-vue'

export default {
  components: {
    BTable,
    BFormCheckbox,
    BAvatar,
    BBadge,
  },
  props: {
    items: Array,
  },
  data() {
    return {
      stickyHeader: true,
      noCollapse: false,
      fields: [
        'name',
        'phone',
        { key: 'message_id', label: 'Status' },
      ],
      status: [{
        1: 'Enviado', 2: 'Falha', 3: 'Aguardando',
      },
      {
        1: 'light-success', 2: 'light-danger', 3: 'light-warning',
      }],
    }
  },
}
</script>
